<div class="card border-0 shadow-sm mb-2 list-card-container {{ customClass() }}"
     [class.placeholder-glow]="isLoading()"
     [class.list-card-shortcut]="isShortcut()">
  @if (isLoading()) {
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="placeholder placeholder-sm col-7 bg-gray-500"></span>
        <span class="placeholder placeholder-sm col-2 bg-gray-500"></span>
      </div>
      <div class="py-1">
        <div class="row g-1 mb-2">
          <div class="col-6">
            <span class="placeholder placeholder-sm col-7 bg-gray-500"></span>
          </div>
          <div class="col-6 text-end">
            <span class="placeholder placeholder-sm col-5 bg-gray-500"></span>
          </div>
          <div class="col-8 mt-1">
            <span class="placeholder placeholder-sm col-8 bg-gray-500"></span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center pt-2 mt-2 border-top border-light">
        <span class="placeholder placeholder-sm col-2 bg-gray-500"></span>
        <span class="placeholder placeholder-lg col-3 bg-gray-500"></span>
      </div>
    </div>
  } @else {
    <div class="list-card-layout" [class.has-shortcut-rail]="isShortcut() || rail()">
      <div class="card-body p-3 list-card-main">
        <div class="d-flex justify-content-between align-items-start mb-2 gap-2">
          <div class="list-card-title flex-grow-1 text-truncate">
            <ng-content select="[cardTitle]"></ng-content>
          </div>
          <div class="list-card-header-end d-flex align-items-center gap-2 flex-shrink-0">
            <ng-content select="[cardBadge]"></ng-content>
            <div class="list-card-actions">
              <ng-content select="[cardActions]"></ng-content>
            </div>
          </div>
        </div>

        <div class="list-card-body text-muted small py-1">
          <ng-content></ng-content>
        </div>

        <div class="list-card-footer d-flex justify-content-between align-items-center pt-2 mt-1">
          <div class="list-card-extra small text-muted">
            <ng-content select="[cardExtra]"></ng-content>
          </div>
          <div class="list-card-amount">
            <ng-content select="[cardAmount]"></ng-content>
          </div>
        </div>
      </div>

      @if (rail()) {
        <div class="list-card-shortcut-rail list-card-control-rail" (click)="$event.stopPropagation()">
          <ng-content select="[cardRail]"></ng-content>
        </div>
      } @else if (isShortcut()) {
        <div class="list-card-shortcut-rail" aria-hidden="true">
          <i class="fas fa-chevron-right"></i>
        </div>
      }
    </div>

    <div class="list-card-actions-row px-3 pb-3 pt-0 w-100">
      <ng-content select="[cardActionsRow]"></ng-content>
    </div>
  }
</div>
